import { automationApiRepository } from '@/forms/api/repository-factory';
import store from '@/store';
import callApiPromo from '@/lib/helpers/call-api-promo';
import getFormatedBornDate2 from '@/forms/helpers/get-formated-born-date2';
import parseExpiryDate from '@/forms/helpers/get-formated-expiry-date';
import FIELD_NAMES from '@/forms/constants/field-names';
import getCountry from '@/forms/helpers/get-country';
import {

    SET_AUTOMATION_RESPONSE,
    CHANGE_VALUE_FIELD
} from '@/lib/constants/mutations';

function getFirstName(name) {


    var newName = name.split(",");
    var firstName = ''

    for (var i = 0; i < newName.length; i++) {
        if (i === 0) {
            if (newName[i]) {
                firstName += newName[i];
            }
        }

    }
    return firstName
}


function getLastName(name) {


    var newName = name.split(",");

    var secondName = ''
    for (var i = 0; i < newName.length; i++) {
        if (i > 0) {
            if (newName[i]) {
                secondName += newName[i] + ' ';
            }
        }

    }
    return secondName
}

function maritalStatus(status) {
    if (
        status.toUpperCase() ===
        "MARRIED"
    ) {
        return "Married";
    } else {
        return "Single";
    }
}

function getMobileNumber(mobile) {
    var m1 = mobile;
    var m2 = m1.substring(1);
    return m2;
}
const parseIdData = data => ({

    [FIELD_NAMES.firstName]: getFirstName(data['fullNameEnglish']),
    [FIELD_NAMES.lastName]: getLastName(data['fullNameEnglish']),
    [FIELD_NAMES.email]: data['email'] === '---' ? '' : data['email'],
    [FIELD_NAMES.phoneNumber]: getMobileNumber(data['mobilePhoneNumber']),
    [FIELD_NAMES.maritalStatus]: maritalStatus(data['maritalStatusCode']),
    [FIELD_NAMES.birthDate]: getFormatedBornDate2(data['dateOfBirth']),
    [FIELD_NAMES.nationality]: getCountry(data['nationalityCode']),
    [FIELD_NAMES.gender]: data['gender'],
    [FIELD_NAMES.emiratesID]: data['eidNumber'],
    [FIELD_NAMES.passportNumber]: data['passportNumber'],
    [FIELD_NAMES.expiryDate]: parseExpiryDate(data['residencyExpiryDate']),
    [FIELD_NAMES.passportExpiryDate]: parseExpiryDate(data['passportExpiryDate']),
    [FIELD_NAMES.residentialEmirate]: data['emiratesDescEnglishWork'],
    [FIELD_NAMES.areaOfWork]: data['emiratesDescEnglishWork'],
    [FIELD_NAMES.residentialEmirateHome]: data['emiratesDescEnglish'],
    [FIELD_NAMES.poBox]: data['pOBOXWork'] === '---' ? '' : data['pOBOXWork'],
    [FIELD_NAMES.workEmail]: data['emailWork'] === '---' ? '' : data['emailWork'],
    [FIELD_NAMES.poBoxHome]: data['pOBOX'] === '---' ? '' : data['pOBOX'],
    [FIELD_NAMES.addressLine1]: data['buildingNameEnglishWork'] === '---' ? '' : data['buildingNameEnglishWork'],
    [FIELD_NAMES.addressLine2]: data['areaDescEnglishWork'] === '---' ? '' : data['areaDescEnglishWork'],
    [FIELD_NAMES.addressLine1Home]: data['buildingNameEnglish'] === '---' ? '' : data['buildingNameEnglish'],
    [FIELD_NAMES.addressLine2Home]: data['areaDescEnglish'] === '---' ? '' : data['areaDescEnglish'],
});


const commitIdInfo = (idInfo) => {
    const idData = parseIdData(idInfo);

    Object.keys(idData).forEach((key) => {
        store.commit(CHANGE_VALUE_FIELD, {
            name: key,
            newValue: idData[key],
            newValidationStates: [],
            edited: false,
        });
    });

    //  store.commit(SET_UPLOADED_OCR, { OCRUpdatedFields: true, idInfo });
};
// export default {
//     async getBranchDetails(currentStep, callbacks) {
//       const { form } = currentStep;
//       let response = false;
//       response = await callApi({
//         callbacks,
//         form,
//         formElement: currentStep,
//         apiCall: branchDetailsRepository.getBranchDetails,

//       });
//     }
//   };

const getPayload = () => {
    const { appId, source } = store.state;
    const { values } = store.state.formData;

    return {
        "ApiName": "read-eid-data",
        "EIDNumber": source

    };
};
export default {
    async getAutomationApi(currentStep, callbacks) {

        const { form } = currentStep;
        let response = false;
        response = await callApiPromo({
            callbacks,
            form,
            formElement: currentStep,
            apiCallPromo: automationApiRepository.getAutomationApi,
            payload: getPayload(),
        });
        if (response) {
            const automationResponse = response[0];
            commitIdInfo(automationResponse);
            store.commit(SET_AUTOMATION_RESPONSE, { automationResponse });

        }
    }
};